// src/components/ProtectedRoute.js

import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import AccessDenied from '../../pages/AccessDenied';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { currentUser, loading } = useAuth(); // AuthContext'ten loading durumunu da alıyoruz
  const location = useLocation();

  // AuthContext hala kullanıcı durumunu kontrol ediyorsa bekleme ekranı göster
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Oturum kontrol ediliyor...</Typography>
      </Box>
    );
  }

  // Yükleme bitti ve kullanıcı yoksa login sayfasına yönlendir
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Eğer bu rota için özel bir rol yetkisi tanımlanmışsa ve kullanıcının rolü bu yetkiler arasında yoksa,
  // kullanıcıyı Erişim Reddedildi sayfasına yönlendir.
  if (allowedRoles && !allowedRoles.includes(currentUser.role)) {
    return <AccessDenied />;
  }

  // Tüm kontrollerden geçerse, istenen sayfayı göster
  return children;
};

export default ProtectedRoute;